import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import ProductCard from "../Components/ProductCard";

const ProductSliderContainer = ({ products, productCount = 2, store }) => {
  const showMore = products && products.length > productCount;
  const responsive = {
    desktop: {
      breakpoint: { max: 10000, min: 1024 },
      items: Number(productCount),
      partialVisibilityGutter: 0,
      slidesToSlide: 2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      partialVisibilityGutter: 0,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1.7,
      partialVisibilityGutter: 0,
      slidesToSlide: 1,
    },
  };
  return (
    <div className="carousel-wrapper">
      <Carousel
        swipeable={true}
        draggable={false}
        // showDots={showMore}
        centerMode={false}
        arrows={showMore}
        responsive={responsive}
        renderArrowsWhenDisabled={true}
        //renderDotsOutside
        partialVisible
        containerClass="carousel-container"
        // dotListClass="custom-dot-list-style"
        // renderButtonGroupOutside={true}
      >
        {products.map((productItem, index) => {
          return <ProductCard key={"product-card-" + index} productItem={productItem} index={index} store={store} />;
        })}
      </Carousel>
    </div>
  );
};

export default ProductSliderContainer;
